import { type ApiResponse, post } from "@src/appV2/api/api";
import { extractPhoneNumberDigits } from "@src/appV2/lib";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const requestProfileOtpRequestSchema = z.object({
  phone: z.string(),
});

const requestProfileOtpResponseSchema = z.object({
  error: z.string().optional(),
  message: z.string().optional(),
});

export type RequestProfileOtpRequest = z.infer<typeof requestProfileOtpRequestSchema>;
export type RequestProfileOtpResponse = z.infer<typeof requestProfileOtpResponseSchema>;
export interface RequestProfileOtpErrorResponse {
  message: string;
  error?: string;
}

export const REQUEST_PROFILE_OTP_PATH = "/agentProfile/requestOTPNew";

export function useRequestProfileOtp(
  options: UseMutationOptions<
    ApiResponse<RequestProfileOtpResponse>,
    AxiosError<RequestProfileOtpErrorResponse>,
    RequestProfileOtpRequest
  > = {}
): UseMutationResult<
  ApiResponse<RequestProfileOtpResponse>,
  AxiosError<RequestProfileOtpErrorResponse>,
  RequestProfileOtpRequest
> {
  return useMutation<
    ApiResponse<RequestProfileOtpResponse>,
    AxiosError<RequestProfileOtpErrorResponse>,
    RequestProfileOtpRequest
  >({
    mutationFn: async ({ phone }) => {
      const phoneNumber = extractPhoneNumberDigits(phone);

      return await post({
        url: REQUEST_PROFILE_OTP_PATH,
        data: { phone: phoneNumber },
        requestSchema: requestProfileOtpRequestSchema,
        responseSchema: requestProfileOtpResponseSchema,
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.REQUEST_OTP_FAILURE,
    },
    ...options,
  });
}
